import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import Popup from 'Edits/Popup';

registerBlockType('eformv4/popup-form', {
	title: __('Popup Form - eForm'),
	icon: 'editor-expand',
	category: 'eform-v4',
	attributes: {
		form_id: {
			type: 'string',
			default: '',
		},
		pos: {
			type: 'string',
			default: 'r',
		},
		style: {
			type: 'string',
			default: 'rect',
		},
		header: {
			type: 'string',
			default: '%FORM%',
		},
		subtitle: {
			type: 'string',
			default: '',
		},
		icon: {
			type: 'string',
			default: 'fa fa-file-text',
		},
		width: {
			type: 'string',
			default: '600',
		},
		color: {
			type: 'string',
			default: '#ffffff',
		},
		bgcolor: {
			type: 'string',
			default: '#3c609e',
		},
		label: {
			type: 'string',
			default: __('Sample Form', 'ipt_fsqm'),
		},
	},

	edit({ attributes, className, setAttributes }) {
		return (
			<Popup
				attributes={attributes}
				className={className}
				setAttributes={setAttributes}
			/>
		);
	},

	save() {
		// Server side rendering
		return null;
	},
});
